import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RxComponent } from '../../common/rx.component';
import { Observable } from 'rxjs/Observable';
import { ChildState } from 'app/core/components/dynamic-onboarding/dynamic-onboarding.component';
import {StepState} from '../../../../shared/components/happy/happy-stepper/happy-stepper.component';

@Component({
  selector: 'itpx-step-template-base',
  template: ''
})
export class StepTemplateBaseComponent extends RxComponent{
  @Input() id: string;
  @Input() parentForm: FormGroup;
  @Input() next: Observable<string>;
  @Input() stepState$: Observable<StepState>;
  @Output() status = new EventEmitter<ChildState>();
  @Output() message = new EventEmitter<{label: string, text: string}>();

  constructor() {
    super();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/dynamic-onboarding/step-template-base/step-template-base.component.ts